import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import XCircleblack from "../../IconComponents/XCircleblack";
import { FaClipboardList, FaExclamationCircle } from "react-icons/fa";
import {
  postDataWithBody,
  postDataWithBodyFrGIS,
} from "../../../Services/Services";
import {
  claimIndTask,
  claimMytask,
  completeIndiTask,
  completeIndivTask,
  completeMytask,
} from "../../../Services/EndPoints";
import { toast, ToastContainer } from "react-toastify";
import { useKeycloak } from "@react-keycloak/web";
import "./TaskModalWithCommentSop.css";

const TaskModalWithCommentSop = (props) => {
  const {
    title,
    titleValue,
    show,
    handleToggle,
    size,
    popupLabel,
    buttonLabel,
    data,
    getMyTaskList,
    setShowPop,
  } = props;
  const [comment, setComment] = useState(data || "");
  const [error, setError] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileError, setFileError] = useState("");
  const [error1, setError1] = useState("");

  const { keycloak } = useKeycloak();

  const todayDate = new Date().toISOString().split("T")[0];

  console.log(props, "props data");

  useEffect(() => {
    if (show) {
      validateCommentLength();
    }
  }, [show]);

  // Function to validate the comment length
  const validateCommentLength = () => {
    if (!comment.trim()) {
      setError("Description is mandatory");
      return false;
    }
    if (comment.length > 250) {
      setError("Maximum 250 characters are allowed.");
      return false;
    }
    setError("");
    return true;
  };

  // Handle comment change and validation
  const handleCommentChange = (e) => {
    const value = e.target.value;
    setComment(value);

    if (!value.trim()) {
      setError("Description is mandatory");
    } else if (value.length > 250) {
      setError("Maximum 250 characters are allowed.");
    } else {
      setError("");
    }
  };

  // Handle file selection
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setFileError("");

    // Check total number of files
    if (selectedFiles.length + files.length > 3) {
      setFileError("You can only upload a maximum of 3 images.");
      return;
    }

    // Validate each file
    const validFiles = [];
    for (let file of files) {
      // Check if file is an image
      if (!file.type.startsWith("image/")) {
        setFileError("Only image files are allowed.");
        return;
      }

      // Check file size (1MB = 1048576 bytes)
      if (file.size > 1048576) {
        setFileError(`File "${file.name}" exceeds 1MB size limit.`);
        return;
      }

      validFiles.push(file);
    }

    // Update selected files
    setSelectedFiles([...selectedFiles, ...validFiles]);
  };

  // Remove selected file
  const removeFile = (indexToRemove) => {
    setSelectedFiles(selectedFiles.filter((_, index) => index !== indexToRemove));
    setFileError("");
  };

  // Format file size for display
  const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + " B";
    else if (bytes < 1048576) return (bytes / 1024).toFixed(2) + " KB";
    else return (bytes / 1048576).toFixed(2) + " MB";
  };

  async function saveConfigData() {
    if (!validateCommentLength()) {
      return;
    }

    // Create FormData object
    const formData = new FormData();

    // Add basic fields
    formData.append("sop_instance_id", props.taskData.sop_instance_id);
    formData.append("task_id", props.taskData.task_id);
    formData.append("description", comment);
    formData.append("user_name", keycloak.idTokenParsed.email);

    // Add files to FormData
    selectedFiles.forEach((file, index) => {
      formData.append(`task_media_files`, file); // or use `task_images_${index}` for individual naming
    });

    let result = null;

    if (props.taskData.task_status_code === "TASK_EXE_STATUS_NEW_TASK") {
      result = await postDataWithBody(claimMytask, formData, {});
    } else if (props.taskData.task_status_code === "TASK_EXE_STATUS_INPROGRESS") {
      result = await postDataWithBody(completeMytask, formData, {});
    }

    try {
      // Send FormData instead of JSON


      if (result && result.status === "success") {
        props.showSuccessMsg();
        toast.success(result.msg, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        setSelectedFiles([]); // Clear files after successful upload
      } else {
        toast.error(result?.msg || "Something went wrong", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        setShowPop(false);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }

      console.log("Input Object: ", props.taskData);
      getMyTaskList();
    } catch (error) {
      console.error("Error uploading task:", error);
      toast.error("Failed to upload task. Please try again.", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  }

  return (
    <>
      <Modal
        show={show}
        onHide={handleToggle}
        size={size}
        className="table__modal__popup task-action-modal"
        centered
      >
        <Modal.Header>
          <Modal.Title>
            <span className="task-icon-badge">
              <FaClipboardList size={14} color="#fff" />
            </span>
            {title}
            {titleValue}
          </Modal.Title>
          <span className="task-close-btn" onClick={handleToggle}>
            <XCircleblack style={{ color: "#fff" }} width="1.1em" height="1.1em" />
          </span>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            {popupLabel && (
              <label className="create__resource--label" htmlFor="tfld_config_value">
                {popupLabel}
              </label>
            )}

            <span className="task-label">Description</span>
            <div className="task-desc-box">{props.taskData.description}</div>

            <span className="task-label">
              Action Taken <span style={{ color: "#e74c3c" }}>*</span>
            </span>
            <textarea
              type="text"
              maxLength={250}
              placeholder="Write your action here"
              className="task-textarea"
              id="modal_comment_txt_area"
              value={comment}
              onChange={handleCommentChange}
            />
            <div className="task-counter">{comment.length}/250</div>
            {error && (
              <div className="task-error">
                <FaExclamationCircle size={12} />
                {error}
              </div>
            )}

            {/* Image Upload Section */}
            <div className="mt-3">
              <span className="task-label">
                Attach Images (Optional — max 3 images, 1MB each)
              </span>
              <div className="task-upload-zone">
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={handleFileChange}
                  className="form-control"
                  disabled={selectedFiles.length >= 3}
                />
              </div>
              {fileError && (
                <div className="task-error">
                  <FaExclamationCircle size={12} />
                  {fileError}
                </div>
              )}

              {/* Display selected files */}
              {selectedFiles.length > 0 && (
                <div className="mt-3">
                  <span className="task-label">
                    Selected Images ({selectedFiles.length}/3)
                  </span>
                  <div className="selected-files-list">
                    {selectedFiles.map((file, index) => (
                      <div
                        key={index}
                        className="task-file-row d-flex align-items-center justify-content-between p-2 mb-2"
                      >
                        <div className="d-flex align-items-center">
                          <img
                            src={URL.createObjectURL(file)}
                            alt={file.name}
                            style={{
                              width: "44px",
                              height: "44px",
                              objectFit: "cover",
                              borderRadius: "6px",
                              marginRight: "10px",
                            }}
                          />
                          <div>
                            <div style={{ fontSize: "13px", fontWeight: 500 }}>
                              {file.name}
                            </div>
                            <div style={{ fontSize: "11px", color: "#8a97a3" }}>
                              {formatFileSize(file.size)}
                            </div>
                          </div>
                        </div>
                        <span
                          className="task-file-remove"
                          onClick={() => removeFile(index)}
                          title="Remove"
                        >
                          <XCircleblack width="0.85em" height="0.85em" />
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={saveConfigData}
            type="button"
            className="btn-save"
            disabled={error !== "" || comment.length === 0}
          >
            {buttonLabel}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TaskModalWithCommentSop;